module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-type jumbotron d-flex align-items-center",
    style: (("background: " + (_vm.calendarType.bgColor) + ";"))
  }, [_c('div', {
    staticClass: "calendar-type-info flex-grow-1"
  }, [_c('span', [_vm._v(_vm._s(_vm.calendarType.name))])]), _vm._v(" "), _c('div', {
    staticClass: "calendar-type-actions"
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "type": "button",
      "variant": "outline-danger",
      "title": "Type verwijderen"
    },
    on: {
      "click": _vm.doDelete
    }
  }, [(!_vm.isDeleting) ? _c('fa-icon', {
    attrs: {
      "icon": "trash"
    }
  }) : _c('loader-spinner', {
    attrs: {
      "iscolor": "#F0F0F0",
      "show-spinner": true
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "ml-1",
    attrs: {
      "type": "button",
      "variant": "outline-primary",
      "title": "Type verwijderen"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('edit', _vm.calendarType.id)
      }
    }
  }, [_c('fa-icon', {
    attrs: {
      "icon": "edit"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24ec79b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Planning/CalendarType.vue
// module id = 1291
// module chunks = 1